import { ChangeDetectorRef, Component, Input, Renderer2, Inject, inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TgSettingsService } from "app/services/TG-Setting_Services/tg-settings.service";
import { TranslationInitService } from 'app/services/Translate_Services/translation-init.service';
import { WidgetInput } from 'app/Modules/Common/Models/widget.model';
import { ClickToToggleDirective } from 'app/Modules/Common/Directives/click-to-toggle.directive';
import { AppStateService } from 'app/Modules/Common/Services/app-state.service';
import { CommunicationService } from 'app/services/communication.service';
import { Subscription } from 'rxjs';
import { forEach } from 'lodash';
import { HostListener } from '@angular/core';
import { NgEnterDirective } from 'app/Modules/Common/Directives/ng-enter.directive';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, ClickToToggleDirective],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
  translateStrings: any = {};
  showLeaveDialog: boolean = false;
  tgSettings: any = {};
  previous: any;
  CurrentId: any;
  SecondLevelid: any;
  customHomepage: boolean = false;
  notificationShow: any;
  notificationView: any;
  sendToFriendInfo: any;
  applyPreloadJSON: any;
  showLocalesDialogBox: boolean = false;
  daysInDraft: number | undefined;
  bSaveDraft: boolean = false;
  pageType: string = '';
  isMobile = false;
  bStandAloneAssessView = false;
  bShowBackButton = true;
  bLoggedIn = false;
  DropDownExpnaded = false;
  bresponsiveCandidateZone = false;
  bellNumber = 0;
  headerClicked: any;
  communicationPanelShown = false;
  configMode = false;
  AnonymousLoginType = '';
  isNonProfileAllowed = false;
  standAloneGQ = 0;
  showInFullView = false;
  bFromTalentSuite = false;
  bPhoneViewLinksVisible = false;
  onOff = false;
  headerInfo: any[] = [];
  dropdownExpanded: boolean[] = [];
  activeDropdownIndex = -1;
  currentDropdownItems: any[] = [];
  secondLevelStates: boolean[] = [];
  activeDropdownClass = '';
  dropDownContent: any = [];
  mobileScreen: any;
  bcandidatezoneSubmenu = false;
  candidateZoneLinks: any[] = [];
  statusOfSecondLevelDropdown: any;
  BrandConfig = "";
  primaryHeaderLogo: any;
  secondaryHeaderLogo: any;
  footerLogo: any;
  favicon: any;
  headerbackgorundcolor: any;
  hidetogglebutton: boolean = false;
  disableClick: boolean = false;
  name: string = '';
  chevronClassName: string = '';



  private sub!: Subscription;
  constructor(private cdr: ChangeDetectorRef,private tgSettingsService: TgSettingsService, private appStateService: AppStateService, private renderer: Renderer2, private communicationService: CommunicationService, private translationInitService: TranslationInitService,) {
    this.tgSettingsService.settings$.subscribe(settings => {
      this.tgSettings = settings?.tgSettings || {};
      this.headerInfo = settings?.headerInfo || [];
      if (this.tgSettings["Responsive_CustomTemplate"] > 0) {
        this.customHomepage = true;
      }
      console.log('Real TgSettings is now set:', this.tgSettings);
      this.cdr.markForCheck();
    });

  }

  @Input() set importHeaderinfo(data: any) {
    if (data != undefined && data != null && data.clientsettings != undefined && data.clientsettings != null && data.headerinfo != undefined && data.headerinfo != null) {
      this.headerInfo = data.headerinfo;
      this.tgSettings = data.clientsettings || {};
      this.hidetogglebutton = true;
      this.disableClick = true;
      this.customHomepage = this.tgSettings["Responsive_CustomTemplate"] > 0 ? true : false;
      this.setBrandingConfiguration(data.visualbrandingconfiguration);
      this.cdr.markForCheck();
      this.dropDownContent = this.headerInfo[0]?.CustomHeaderLinksInfo?.SubHeader || this.headerInfo[0]?.customHeaderLinksInfo?.items || [];
    }
  }


  @Input() set widgetData(data: WidgetInput) {
    if (data) {
      this.translateStrings = data.TranslateStrings || {};
      this.tgSettings = data.tgsetting || {};
    }
  }
  @HostListener('window:resize')
  onResize() {
    this.mobileScreen = window.innerWidth <= 768;
  }
  ngOnInit(): void {
    if (this.tgSettings["Responsive_CustomTemplate"] > 0) {
      this.customHomepage = true;
    }
    this.mobileScreen = window.innerWidth <= 768;
  }
  togglePhoneMenu() {
    this.bPhoneViewLinksVisible = !this.bPhoneViewLinksVisible;
  }
  closeHeader() {
    const element = document.querySelector(".threeLineIcon") as HTMLElement;
    if (element) { element.click(); }
  }

  toggleNotification() {
    this.communicationPanelShown = !this.communicationPanelShown;
    const bellIcon = document.querySelector(".bellIcon.threeLineIcon") as HTMLElement;
    if (bellIcon) {
      bellIcon.setAttribute("aria-expanded", this.communicationPanelShown.toString());
    }
    if (this.communicationPanelShown) {
      this.notificationView = this.notificationShow ? 'notification' : 'message';
      // this.NotificationMenu(this.notificationView);
    }

    setTimeout(() => {
      const notificationBox = document.getElementById("notificationBoxContainer");
      if (notificationBox) {
        notificationBox.style.display = this.communicationPanelShown ? 'block' : 'none';
      }
      if (this.communicationPanelShown) {
        const currentTab = document.querySelector(".NotificationMenu .CurrentTab") as HTMLElement;
        currentTab?.focus();
      } else {
        const rightIcons = document.querySelector(".rightIcons") as HTMLElement;
        rightIcons?.focus();
      }
    }, 0);
  }

  toggleDropdown(index: number, event: Event) {
    event.preventDefault();
    this.activeDropdownIndex = index;
    this.dropdownExpanded[index] = !this.dropdownExpanded[index];
    this.currentDropdownItems = this.headerInfo[index]?.customHeaderLinksInfo?.items || [];
  }

  handleFirstLevelClick(item: any, event: Event) {
    if (item.lowlevelSubHeader?.length > 0) {
      const j = this.currentDropdownItems.indexOf(item);
      this.secondLevelStates[j] = !this.secondLevelStates[j];
    } else if (item.url) {
      event.preventDefault();
      const metaEl = document.getElementById('pagemetadata') as HTMLInputElement;
      const gqData = metaEl?.value ? JSON.parse(metaEl.value) : null;
      const saveDraftBtn = document.getElementById('saveasdraft') as HTMLElement;
      const saveDraft = !!(saveDraftBtn && saveDraftBtn.offsetParent !== null);
    }
  }
  closeDropdown() {
    this.dropdownExpanded.fill(false);
    this.activeDropdownIndex = -1;
  }
  closeSecondLevel() {
    this.secondLevelStates.fill(false);
  }
  handleSecondLevelClick(child: any, event: Event) {
    if (child.url) {
      event.preventDefault();
      const metaEl = document.getElementById('pagemetadata') as HTMLInputElement;
      const gqData = metaEl?.value ? JSON.parse(metaEl.value) : null;
      const saveDraftBtn = document.getElementById('saveasdraft') as HTMLElement;
      const saveDraft = !!(saveDraftBtn && saveDraftBtn.offsetParent !== null);
    }
  }

  switchDarkMode(isDark: boolean) {
    const htmlElement = document.documentElement;
    if (isDark) {
      htmlElement.classList.add('darkmode');
    } else {
      htmlElement.classList.remove('darkmode');
    }
    document.body.classList.toggle('dark-mode', isDark);
    this.onToggleDarkCallEntIframes(isDark);
  }

  private onToggleDarkCallEntIframes(modeType: boolean): void {
    let iFrameId = '';
    const interviewDetailFrame = document.getElementById('interviewDetail') as HTMLIFrameElement;
    const portalFormFrame = document.getElementById('PortalForm') as HTMLIFrameElement;
    if (interviewDetailFrame && this.isElementVisible(interviewDetailFrame)) {
      iFrameId = 'interviewDetail';
    } else if (portalFormFrame && this.isElementVisible(portalFormFrame)) {
      iFrameId = 'PortalForm';
    }
    if (iFrameId) {
      const myIframe = document.getElementById(iFrameId) as HTMLIFrameElement;
      if (myIframe && myIframe.contentWindow) {
        const message = modeType ? 'enDarkModeFromTG' : 'enLightModeFromTG';
        myIframe.contentWindow.postMessage(message, '*');
      }
    }
  }

  private isElementVisible(element: HTMLElement): boolean {
    return !!(element.offsetParent !== null);
  }

  getNewNotificationText(): string {
    const template = this.translateStrings['ScreenReaderText_NewBellNotification'];
    if (template && this.bellNumber > 0) {
      return template.replace('[NewNotificationsCount]', this.bellNumber.toString());
    }
    return this.bellNumber > 0
      ? `${this.bellNumber} new notification${this.bellNumber === 1 ? '' : 's'}`
      : this.translateStrings['ScreenReaderText_BellNotification'] || 'No new notifications';
  }
  CloseHeaderLinkdropdown() {
    this.DropDownExpnaded = false;
    document.querySelectorAll(".Dsecond_level_menu").forEach((el: any) => (el as HTMLElement).style.display = 'none');
    document.querySelectorAll(".CustomDropDown .fa-chevron-up").forEach((el: any) =>
    {
      el.classList.remove("fa-chevron-up");
      el.classList.add("fa-chevron-down");
    });
    if (this.chevronClassName.includes('fa-chevron-down'))
    {
      this.chevronClassName = this.chevronClassName.replace('fa-chevron-down', 'fa-chevron-up');
    }
    else if (this.chevronClassName.includes('fa-chevron-up'))
    {
      this.chevronClassName = this.chevronClassName.replace('fa-chevron-up', 'fa-chevron-down');
    }
    setTimeout(() =>
    {
      const focusElement = document.getElementById(this.name);
      if (focusElement) focusElement.focus();
    }, 100);

    if (this.SecondLevelid)
    {
      Array.from(this.SecondLevelid).forEach((el: any) => el.setAttribute("aria-expanded", "false"));
    }
  }
  customHeaderLinkDropdown(event: any)
  {
    this.SecondLevelid = document.getElementsByClassName("DropdownLabel");
    Array.from(this.SecondLevelid).forEach((el: any) => el.setAttribute("aria-expanded", "false"));

    if (this.bcandidatezoneSubmenu == true)
    {
      this.bcandidatezoneSubmenu = false;
      const candZoneIcon = document.querySelector("#responsiveCandZoneLink i");
      if (candZoneIcon)
      {
        candZoneIcon.classList.remove('fa-chevron-up');
        candZoneIcon.classList.add('fa-chevron-down');
      }
    }
    event.preventDefault();
    event.stopPropagation();

    const currentTarget = event.currentTarget as HTMLElement;
    const DSecondLevelMenuElement = currentTarget.querySelector(".Dsecond_level_menu") as HTMLElement;
    
    // attributes[0] might not be the ID depending on the browser/HTML structure.
    // Safer to use currentTarget.id or getAttribute('id').
    this.CurrentId = currentTarget.id || currentTarget.getAttribute('id');

    if (this.previous && this.previous == currentTarget.id)
    {
      if (DSecondLevelMenuElement)
      {
        DSecondLevelMenuElement.style.right = "-210px";
        DSecondLevelMenuElement.style.display = 'none';
      }
      currentTarget.setAttribute("aria-expanded", "false");
      this.previous = null;
      this.statusOfSecondLevelDropdown = false;
    }
    else
    {
      document.querySelectorAll(".Dsecond_level_menu").forEach((el: any) => el.style.display = 'none');
      
      if (DSecondLevelMenuElement)
      {
        if (DSecondLevelMenuElement.style.display === 'none' || !DSecondLevelMenuElement.style.display)
        {
          DSecondLevelMenuElement.style.display = 'block';
          currentTarget.setAttribute("aria-expanded", "true");
          
          DSecondLevelMenuElement.querySelectorAll(".DropdownLabel").forEach((el: any) => el.removeAttribute("aria-expanded"));
          
          if ((window.innerWidth - DSecondLevelMenuElement.getBoundingClientRect().left) < 210 && !this.mobileScreen)
          {
            DSecondLevelMenuElement.style.right = "210px";
          }
        }
        else
        {
          DSecondLevelMenuElement.style.display = 'none';
          currentTarget.setAttribute("aria-expanded", "false");
        }
      }
      this.previous = currentTarget.id;
    }
  }

  ClosedSecondLeveldropdown()
  {
    const element = document.querySelector(".Dsecond_level_menu") as HTMLElement;
    if (element) {
      element.style.display = 'none';
    }
    this.previous = null;
    this.statusOfSecondLevelDropdown = false;
    const focusElement = document.getElementById(this.CurrentId) as HTMLElement;
    if (focusElement) {
      focusElement.focus();
    }
    if (this.SecondLevelid)
    {
      Array.from(this.SecondLevelid).forEach((el: any) => el.setAttribute("aria-expanded", "false"));
    }
    return false;
  }

  setBrandingConfiguration(data: any) {
    if (data != undefined && data != "" && data != null) {
      const rawdata = JSON.parse(unescape(data));
      forEach(rawdata, (item) => {
        forEach(item, (value, key) => {
          if (key.includes('PrimaryHeaderLogo')) {
            this.primaryHeaderLogo = value;
          }
          if (key.includes('Responsive_HeaderBackgroundColor')) {
            this.headerbackgorundcolor = value;
            document.documentElement.style.setProperty('--header-background-colorJSP', value);
          }
        });
      });
    }
  }
  onHeaderLinkClick(link: any, event: MouseEvent, index: number) {
    // Prevent the default browser behavior (important!)
    event.preventDefault();
    event.stopPropagation();   // optional - prevents bubbling

    // // Skip confirmation for json dropdown items (as per your ngClass logic)
    // if (link.ContentType === 'json') {
    //   // handle your dropdown logic here if needed
    //   return;
    // }
    console.log('Header link clicked:', link.ContentType, link.Url);
    // Optional: you can skip confirmation for internal links or specific conditions
    // if (link.Url?.startsWith('/')) { window.location.href = link.Url; return; }

    const url = link.Value;   // ← adjust property name if different (href, link, url, etc.)

    if (!url) {
      console.warn('No URL found for link', link);
      return;
    }


  }  HeaderLinkDropdown(evt: any, index: number)
  {
    if (this.bcandidatezoneSubmenu == true)
    {
      this.bcandidatezoneSubmenu = false;
      const candZoneLink = document.querySelector("#responsiveCandZoneLink i");
      if (candZoneLink) {
        candZoneLink.classList.remove('fa-chevron-up');
        candZoneLink.classList.add('fa-chevron-down');
      }
    }

    this.name = evt.currentTarget.id;
    this.headerClicked = index;
    evt.preventDefault();
    evt.stopPropagation();

    const hideDropdown = (e: any) =>
    {
      const target = e.target as HTMLElement;
      if (!target.closest('.Dfirst_level_menu'))
      {
        document.querySelectorAll(".Dfirst_level_menu").forEach((el: any) => el.style.display = 'none');
        document.removeEventListener('click', hideDropdown);
        this.previous = null;
        document.querySelectorAll(".Dsecond_level_menu").forEach((el: any) => el.style.display = 'none');
        this.DropDownExpnaded = false;
        document.querySelectorAll(".CustomDropDown .fa-chevron-up").forEach((el: any) => {
          el.classList.remove("fa-chevron-up");
          el.classList.add("fa-chevron-down");
        });
      }
    };

    document.addEventListener('click', hideDropdown);
    
    // In Angular with *ngIf, the element might not be rendered yet.
    // However, we look for existing ones to get the base ID structure.
    const firstLevelMenu = document.querySelector(".Dfirst_level_menu") as HTMLElement;
    var dropdownClassName = firstLevelMenu?.id;
    
    // Fallback if not found (happens on first open with *ngIf)
    if (!dropdownClassName) {
      dropdownClassName = "Dfirst_level_menu" + index;
    }

    var id2 = dropdownClassName.replace(/[0-9]+$/, ''); // Remove trailing numbers
    var latestClassName = id2 + index;

    const target = evt.currentTarget as HTMLElement;
    const targetIcon = target.querySelector('i');
    
    this.chevronClassName = target.classList.contains("CustomDropDown")
      ? target.children[0]?.className || ""
      : target.querySelector(".CustomDropDown i")?.className || "";

    const targetLeft = target.offsetLeft;
    const targetTop = target.offsetTop;

    setTimeout(() => {
      const menus = document.querySelectorAll('.Dfirst_level_menu') as NodeListOf<HTMLElement>;
      menus.forEach(menu => {
        menu.style.left = targetLeft + "px";
        menu.style.top = (targetTop + 20) + "px";
      });

      if (document.querySelector("#header" + this.headerClicked + " i")?.classList.contains("fa-chevron-down"))
      {
        const menuToHide = document.getElementById(latestClassName);
        if (menuToHide) menuToHide.style.display = 'none';
        this.DropDownExpnaded = false;
        this.previous = null;
        document.querySelectorAll(".Dsecond_level_menu").forEach((el: any) => el.style.display = 'none');
      } else
      {
        const menuToShow = document.getElementById(latestClassName);
        if (menuToShow) menuToShow.style.display = 'block';
        this.previous = null;
      }
    }, 10);

    setTimeout(() =>
    {
      (document.querySelector(".DropdownLabel") as HTMLElement)?.focus();
    }, 1000);

    document.querySelectorAll(".Dsecond_level_menu").forEach((el: any) => (el as HTMLElement).style.right = "-210px");
    if (window.innerWidth - targetLeft < 420 && !this.mobileScreen)
    {
        document.querySelectorAll(".Dsecond_level_menu").forEach((el: any) => (el as HTMLElement).style.right = "210px");
    }

    document.querySelectorAll(".CustomDropDown .fa-chevron-up").forEach((el: any) => {
        el.classList.remove("fa-chevron-up");
        el.classList.add("fa-chevron-down");
    });

    if (this.chevronClassName.includes('fa-chevron-down'))
    {
      this.chevronClassName = this.chevronClassName.replace('fa-chevron-down', 'fa-chevron-up');
    } else if (this.chevronClassName.includes('fa-chevron-up'))
    {
      this.chevronClassName = this.chevronClassName.replace('fa-chevron-up', 'fa-chevron-down');
      this.DropDownExpnaded = false;
    }

    const iconToToggle = target.querySelector(".CustomDropDown i") || target.querySelector("i");
    if (iconToToggle) {
        iconToToggle.className = this.chevronClassName;
    }

    this.DropDownExpnaded = !this.DropDownExpnaded;
  }


}
